import { ChevronLeft, ChevronRight } from "lucide-react";

interface Props {
  /** 形如 "2026-05" */
  value: string;
  onChange: (v: string) => void;
}

function shiftMonth(v: string, delta: number): string {
  const [y, m] = v.split("-").map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

const arrow =
  "flex h-full w-8 items-center justify-center text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring";

export function MonthSelector({ value, onChange }: Props) {
  return (
    <div className="inline-flex h-9 items-stretch overflow-hidden rounded-lg border border-input bg-card shadow-sm">
      <button type="button" onClick={() => onChange(shiftMonth(value, -1))} className={arrow} aria-label="上一个月">
        <ChevronLeft className="h-4 w-4" />
      </button>
      <input
        type="month"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="月份"
        className="w-[8.5rem] border-x border-input bg-transparent px-2 text-sm tabular-nums text-foreground outline-none focus-visible:bg-primary-soft"
      />
      <button type="button" onClick={() => onChange(shiftMonth(value, 1))} className={arrow} aria-label="下一个月">
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
}
